import { render, staticRenderFns } from "./OptionAccordion.vue?vue&type=template&id=0435f484&scoped=true&"
import script from "./OptionAccordion.vue?vue&type=script&lang=ts&"
export * from "./OptionAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./OptionAccordion.vue?vue&type=style&index=0&id=0435f484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435f484",
  null
  
)

export default component.exports